import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { select } from '@/store'

const usePayment = ({ paymentId, listingId }) => {
  const dispatch = useDispatch()
  const loadPaymentData = dispatch.payment.getPayment
  const paymentData = useSelector(state => select.payment.payment(state, { paymentId, listingId }))
  useEffect(() => {
    const hasPaymentId = typeof paymentId !== 'undefined'
    if (hasPaymentId) {
      loadPaymentData({ paymentId })
    }
  }, [loadPaymentData, paymentId])
  return paymentData
}

export default usePayment
